import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';

import Heading from '@marvelapp/marvel-ui/heading';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import Button from '@marvelapp/marvel-ui/button';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Spacing from '@marvelapp/marvel-ui/spacing';

import Image from 'marketing-website/components/modules/Image';

import styles from './style/header.module.css';

export default function IndustryHeader({
  label,
  imageAsset,
  title,
  paragraph,
  ctaLink,
}) {
  const buttons = (
    <Spacing size="m" sizeM="l" position="top" type="margin">
      <div className={styles.buttons}>
        <div className={styles.leftButton}>
          <Link to={ctaLink}>
            <Button
              size="large"
              background="blue"
              hover="blue"
              shape="rounded"
              minWidth={180}
            >
              Request a demo
            </Button>
          </Link>
        </div>
      </div>
    </Spacing>
  );

  return (
    <div className={styles.flex}>
      <div className={styles.firstCol}>
        <div>
          <Spacing size="s" position="bottom" type="margin">
            <Heading tag="h1" size="m" weight="semibold">
              <span className={styles.label}>{label}</span>
            </Heading>
          </Spacing>
          <h1 className={styles.heading}>{title}</h1>
          <MaxWidth value={500}>
            <Spacing size="s" position="top" type="margin">
              <Paragraph size="m" color="black">
                {paragraph}
              </Paragraph>
            </Spacing>
          </MaxWidth>
          {buttons}
        </div>
      </div>
      <div className={styles.secondCol}>
        <Image {...imageAsset} hasShadow={false} block />
      </div>
    </div>
  );
}

IndustryHeader.propTypes = {
  imageAsset: PropTypes.object,
  label: PropTypes.string,
  title: PropTypes.string,
  paragraph: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  ctaLink: PropTypes.string.isRequired,
};

IndustryHeader.defaultProps = {
  ctaLink: '/enterprise/request-demo',
};



// WEBPACK FOOTER //
// ./src/components/modules/IndustryHeader/index.js